"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="hero" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/aburra_valley_dusk.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/aburra_valley_dusk.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/aburra_valley_dusk.png-wvc-sizes" alt="Cinematic view of the Aburrá Valley at dusk" className="h-full w-full object-cover object-center" loading="eager" decoding="async" />
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-black via-black/70 to-black/20" />

      {}
      <div ref={contentRef} className="relative z-10 flex max-w-5xl flex-col items-center justify-center px-6 text-center">
        <h1 className={`font-default text-5xl font-light leading-tight tracking-wide text-secondary transition-all duration-1000 ease-out md:text-7xl lg:text-[5rem] ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: "100ms"
      }}>
          The Aburrá Valley
        </h1>

        <p className={`mt-6 max-w-2xl font-sans text-lg text-accent transition-all duration-1000 ease-out md:text-xl ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: "300ms"
      }}>
          Experience the breathtaking beauty of Colombia's most vibrant landscape, where nature and culture intertwine at dusk.
        </p>

        <div className={`mt-10 transition-all duration-1000 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-[20px] opacity-0"}`} style={{
        transitionDelay: "500ms"
      }}>
          <Button asChild size="lg" className="rounded-sm bg-primary px-8 py-6 text-lg text-primary-foreground shadow-md transition-all duration-300 hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/40">
            <Link to="/MedellinPage">Explore the Valley</Link>
          </Button>
        </div>
      </div>
    </section>;
}